const areaColumns = [
  {
    label: 'Area',
    value: 'name',
    textId: 'fleetadmin.area.table.area',
    disabled: true,
  },
  {
    label: 'Fleet',
    value: 'fleetId',
    textId: 'fleetadmin.area.table.fleet',
    disabled: false,
  },
  {
    label: 'Fleet Style',
    value: 'fleetStyle',
    textId: 'fleetadmin.area.table.fleetstyle',
    disabled: false,
  },
  {
    label: 'No.Vehicles',
    value: 'id',
    textId: 'fleetadmin.area.table.novehicles',
    disabled: false,
  },
  {
    label: 'Created at',
    value: 'createdAt',
    textId: 'fleetadmin.area.table.createdat',
    disabled: false,
  },
  {
    label: 'Last modified',
    value: 'lastUpdatedAt',
    textId: 'fleetadmin.area.table.lastmodified',
    disabled: false,
  },
  {
    label: 'Location',
    value: 'location',
    textId: 'fleetadmin.area.table.location',
    disabled: false,
  },
  {
    label: 'Action',
    value: 'operation',
    textId: 'fleetadmin.area.table.action',
    disabled: false,
  },
];

export const defaultSelectedAreaColumns = areaColumns.map(
  (areaColumn) => areaColumn.value
);

export default areaColumns;
